import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledMilestonesIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 12,
			fill: "#D5F0F7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20.0005,
			r: 10.5,
			fill: "white",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.7247 14.4635C19.8743 14.0029 20.526 14.0029 20.6757 14.4635L21.6595 17.4914C21.7265 17.6974 21.9185 17.8369 22.1351 17.8369H25.3188C25.8031 17.8369 26.0045 18.4567 25.6126 18.7414L23.037 20.6127C22.8617 20.74 22.7884 20.9657 22.8554 21.1717L23.8392 24.1996C23.9888 24.6602 23.4616 25.0433 23.0697 24.7586L20.4941 22.8873C20.3188 22.76 20.0815 22.76 19.9063 22.8873L17.3306 24.7586C16.9388 25.0433 16.4116 24.6602 16.5612 24.1996L17.545 21.1717C17.612 20.9657 17.5386 20.74 17.3634 20.6127L14.7877 18.7414C14.3959 18.4567 14.5973 17.8369 15.0816 17.8369H18.2653C18.4819 17.8369 18.6739 17.6974 18.7409 17.4914L19.7247 14.4635Z",
			fill: "#4B7987",
			stroke: "#1F3B44"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledMilestonesIcon);
const Memo = memo(ForwardRef);
export default Memo;
